module.exports = require('./modules/helpers/transitionTo');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/transitionTo.js
// module id = 217
// module chunks = 0